import React, { Component } from "react";

/*
PROPS
- skills {title, color}
*/

/*
PROPS
- skills
*/
class SkillsRow extends Component {
  render() {
    return (
      <div className={"row flex-wrap " + this.props.className}>
        {this.props.skills.map((obj) => {
          return (
            <div
              className={" p-v-xs p-h-s border-radius-s mr-r mb-r " + obj.color}
            >
              {obj.title}
            </div>
          );
        })}
      </div>
    );
  }
}

export default SkillsRow;
